module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', [(_vm.site_view == 2) ? _c('div', [_c('component-desktop')], 1) : _c('div', [_c('div', {
    staticClass: "main-wrap-xx",
    staticStyle: {
      "background-color": "#fafafa"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(((Object.keys(_vm.menu_tab_inner_view).length == 0) || (_vm.menu_tab_inner_view.length == 0) || (_vm.menu_tab_inner_view['']))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    staticClass: "row-x",
    staticStyle: {
      "width": "100vw",
      "height": "200px",
      "background-repeat": "no-repeat",
      "background-size": "cover",
      "border-radius": "28px 28px 0px 0px"
    },
    style: ({
      'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.397), rgba(8, 8, 8, 0.311)), url(' + _vm.business_display_image + ')'
    })
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "1em",
      "padding-bottom": "1em"
    }
  }, [_c('h2', {
    staticClass: "ttrog",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "prd-descr",
    staticStyle: {
      "line-height": "1.8",
      "color": "#ffffff"
    }
  }, [_vm._v("Enjoy from " + _vm._s(_vm.app_name) + ", we are here to serve you with your best local and \r\n                international\r\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "width": "100%",
      "background": "#ffffff",
      "margin-top": "-1.05em",
      "border-radius": "18px 18px 0px 0px",
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "-1em",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "0px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('items-list')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])])])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.menu_tab_inner_view).length == 0) || (_vm.menu_tab_inner_view.length == 0) || (_vm.menu_tab_inner_view['']))) ? _c('div', [(_vm.set_order_list.length == 0) ? _c('component-footer') : _vm._e()], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "18px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa602ba"}!./src/pages/Business/template.html
// module id = 612
// module chunks = 0